import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Paper,
  TextField,
  Select,
  MenuItem,
  Stack,
} from "@mui/material";
import EditManual from "./ManualComponent/EditManual";
import LogsButton from "./ManualComponent/LogsButton";
import DownloadButton from "./ManualComponent/DownloadButton";
import FullyEditButton from "./ManualComponent/FullyUpdateManual";
import { updateManual } from "../../../utils/updateManual";
import { fetchManualData } from "../../../api/fetchManualData"; // Import fetch function
import { formatDate } from "../../../utils/formatDate";

//
function QualityManualForm({ onShowLogs }) {
  const [recordId, setRecordId] = useState(""); // Store the record ID
  const [versionNumber, setVersionNumber] = useState("");
  const [revisionNotes, setRevisionNotes] = useState("");
  const [approvalAuthority, setApprovalAuthority] = useState("");
  const [controlledCopyLink, setControlledCopyLink] = useState("");
  const [effectiveDate, setEffectiveDate] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      const data = await fetchManualData();
      if (data.length > 0) {
        const manual = data[0]; // Assuming you want the first record
        setRecordId(manual.id);
        setVersionNumber(manual.versionNumber);
        setRevisionNotes(manual.revisionNotes);
        setApprovalAuthority(manual.approvalAuthority);
        setControlledCopyLink(manual.controlledCopyLink);

        // Use the original date value directly if it's in the correct format
        const originalDate = manual.effectiveDate; // e.g., "09-May-2025"
        if (originalDate) {
          // Convert "09-May-2025" to "2025-05-09" for the input field
          const [day, month, year] = originalDate.split("-");
          const monthIndex = new Date(`${month} 1, 2000`).getMonth() + 1; // Get month index
          const formattedDate = `${year}-${String(monthIndex).padStart(
            2,
            "0"
          )}-${day}`;
          setEffectiveDate(formattedDate);
        } else {
          setEffectiveDate(""); // Clear the field if no date is available
        }
      } else {
        console.warn("⚠️ No Quality Manual data found.");
      }
    };

    fetchData();
  }, []);

  const handleUpdateManual = async () => {
    // Format the Effective_Date to dd-MMM-yyyy before sending to the API
    const formattedEffectiveDate = formatDate(new Date(effectiveDate));

    if (!formattedEffectiveDate) {
      alert("Enter a valid date format for Effective Date");
      return;
    }

    const updateData = {
      Version_Number: versionNumber,
      Revision_Notes: revisionNotes,
      Approval_Authority: approvalAuthority,
      Controlled_Copy_Link: controlledCopyLink,
      Effective_Date: formattedEffectiveDate, // Use the formatted date
    };

    const success = await updateManual(recordId, updateData);
    if (success) {
      console.log("Manual updated successfully.");
    }
  };

  return (
    <Box mt={0}>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        mb={2}
      >
        <Typography variant="h6" fontWeight="bold" sx={{ color: "#4F46E5" }}>
          Quality Manual
        </Typography>
        <Stack direction="row" spacing={1} mt={2}>
          <EditManual onUpdate={handleUpdateManual} />
          <FullyEditButton />
          <DownloadButton />
          <LogsButton onShowLogs={onShowLogs} />
        </Stack>
      </Stack>
      <Stack spacing={1.5}>
        <Stack direction={{ xs: "column", md: "row" }} spacing={1}>
          <TextField
            id="Controlled_Copy_Link"
            fullWidth
            label="Controlled Copy Link"
            placeholder="https://example.com/manual.pdf"
            size="small"
            value={controlledCopyLink}
            onChange={(e) => setControlledCopyLink(e.target.value)}
          />
          <Select
            id="approval_authority"
            fullWidth
            displayEmpty
            size="small"
            value={approvalAuthority}
            onChange={(e) => setApprovalAuthority(e.target.value)}
          >
            <MenuItem value="Admins">Admins</MenuItem>
            <MenuItem value="Quality Manager">Quality Manager</MenuItem>
          </Select>
        </Stack>
        <Stack direction={{ xs: "column", md: "row" }} spacing={1}>
          <TextField
            id="version_number"
            fullWidth
            label="Version Number"
            type="number"
            placeholder="e.g. 1.0"
            size="small"
            value={versionNumber}
            onChange={(e) => setVersionNumber(e.target.value)}
          />
          <TextField
            id="Effective_Date"
            fullWidth
            label="Effective Date"
            type="date"
            InputLabelProps={{ shrink: true }}
            size="small"
            value={effectiveDate} // Ensure the value is in yyyy-MM-dd format
            onChange={(e) => setEffectiveDate(e.target.value)}
          />
        </Stack>
        <TextField
          id="revision_notes"
          fullWidth
          label="Revision Notes"
          multiline
          minRows={2}
          placeholder="Describe any changes or updates..."
          size="small"
          value={revisionNotes}
          onChange={(e) => setRevisionNotes(e.target.value)}
        />
      </Stack>
    </Box>
  );
}
export default QualityManualForm;
